package org.example.project.game

import kotlinx.browser.window

/**
 * jsMain (Kotlin/JS Browser) actual.
 *
 * Pfad:
 *   composeApp/src/jsMain/kotlin/org/example/project/game/PlayerIdProvider.js.kt
 *
 * Unterschied zu wasmJs: hier funktioniert direktes js("...") fuer
 * Strings, kein @JsFun noetig.
 */
actual fun getOrCreatePlayerId(): String {
    val storage = window.localStorage
    val existing = storage.getItem("playerId")
    if (!existing.isNullOrBlank()) return existing

    val newId = generateUuidV4()
    storage.setItem("playerId", newId)
    return newId
}

private fun generateUuidV4(): String = js("crypto.randomUUID()") as String
